<template>
    <div class="chat">
        <Navbar />
        <div class="mt-5 pt-5 mb-5 kovatek-width">
            <div class="px-md-3 mx-md-3 px-lg-4 mx-lg-4">
                <div class="text-left mt-3 ml-5 mb-4"><a-icon class="mr-1" type="arrow-left" /> <span class="go-back" @click="goBack">Go Back</span></div>
                <div class="container-fluid">
                    <div class="row mx-0 px-0">
                        <div class="col-12 col-md-5 col-lg-4">
                            <a-input class="mt-4 ctrl-search" size="large" placeholder="Search" ref="userNameInput">
                                <a-icon slot="prefix" type="search" />
                                <a-tooltip slot="suffix" title="Extra information">
                                    <a-icon type="info-circle" style="color: rgba(0,0,0,.45)" />
                                </a-tooltip>
                            </a-input>
                            <div class="bg-light mt-3 rounded border ctrl-light">
                                <!-- <div class="row" :key="n" v-for="n in 8">
                                    <div class="col-4 col-md-3">
                                        <img src="../assets/kovatek/Mask Group 46.svg" alt="" class="rounded-circle mt-3 ml-2 img-height" />
                                    </div>
                                    <div class="col-8 col-md-9 pointer">
                                        <div class="row mt-3">
                                            <div class="col-1">
                                                <div class="dot mt-2"></div>
                                            </div>
                                            <div class="col-8">
                                                <h5 class="kova-text font-weight-bolder text-left mb-0 ctrl-size"> John Joshua</h5>
                                            </div>
                                            <div class="col-1">
                                                <font-awesome-icon class="icon-1 pointer" icon="ellipsis-v"></font-awesome-icon>
                                            </div>
                                        </div>
                                        <p class="text-left mb-0">Hi, I would like to</p>
                                        <div class="text-right">
                                            <p class="ctrl-size-2 font-weight-bolder mr-2 mt-0">Yesterday, 10:45 PM</p>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <hr class="mx-3 my-0">
                                    </div>
                                </div> -->

                                <div class="bg-light">
                                    <div class="" :key="n" v-for="n in 8">
                                        <div class="d-flex pt-2">
                                            <div class="">
                                                <img src="../assets/kovatek/Mask Group 46.svg" alt="" class="rounded-circle ml-2 img-height" />
                                            </div>
                                            <div class="ml-3 mr-auto">
                                                <div class="d-flex">
                                                    <div class="dot mt-2 mr-2"></div>
                                                    <h5 class="kova-text font-weight-bolder text-left mb-1 ctrl-size"> John Joshua</h5>
                                                </div>
                                                <p class="text-left mb-0">Hi, I would like to</p>
                                            </div>
                                            <div class="mr-3">
                                                <font-awesome-icon class="icon-1 pointer mt-2" icon="ellipsis-v"></font-awesome-icon>
                                            </div>
                                        </div>
                                        <div class="">
                                            <p class="ctrl-size-2 font-weight-bolder mr-2 mt-0 text-right pt-0">Yesterday, 10:45 PM</p>
                                        </div>
                                    <hr class="my-0 py-0"/>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-7 col-lg-8">
                            <div class="mt-4">
                                <div class="row mt-4 pt-3 ml-3 w-100">
                                    <div class="col-6">
                                        <div class="row">
                                            <div class="dot mt-2 mx-2"></div>
                                            <div>
                                                <h5 class="kova-text font-weight-bolder text-left mb-0"> John Joshua</h5>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 text-right">
                                        <!-- <div class="row kova-text">
                                            <font-awesome-icon class="icon-1 pointer" icon="microphone"></font-awesome-icon>
                                            <p class="font-weight-bolder ctrl-size-1 mx-2 pointer">Voice Note</p>
                                            <font-awesome-icon class="icon-1 pointer" icon="video"></font-awesome-icon>
                                            <p class="font-weight-bolder ctrl-size-1 ml-2 pointer"> Video Call</p>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                            <div class="border p-4 rounded mt-3">
                                <!-- <div class="p-5 border"></div> -->
                                <div class="chat-panel">
                                    <div class="row no-gutters">
                                    <div class="col-md-6">
                                        <div class="chat-bubble chat-bubble--left text-left">
                                        Hello dude! I just got a message from kovatek.com
                                        </div>
                                    </div>
                                    </div>
                                    <div class="row no-gutters">
                                    <div class="col-md-6 offset-md-6">
                                        <div class="chat-bubble chat-bubble--right text-left">
                                        Hello dude!
                                        </div>
                                    </div>
                                    </div>
                                    <div class="row no-gutters">
                                    <div class="col-md-6 offset-md-6">
                                        <div class="chat-bubble chat-bubble--right text-left">
                                        Hello dude!
                                        </div>
                                    </div>
                                    </div>
                                    <div class="row no-gutters">
                                    <div class="col-md-6">
                                        <div class="chat-bubble chat-bubble--left text-left">
                                        Hello dude!
                                        </div>
                                    </div>
                                    </div>
                                    <div class="row no-gutters">
                                    <div class="col-md-6">
                                        <div class="chat-bubble chat-bubble--left text-left">
                                        Hello dude!
                                        </div>
                                    </div>
                                    </div>
                                    <div class="row no-gutters">
                                    <div class="col-md-6">
                                        <div class="chat-bubble chat-bubble--left text-left">
                                        Hello dude!
                                        </div>
                                    </div>
                                    </div>
                                    <div class="row no-gutters">
                                    <div class="col-md-6 offset-md-6">
                                        <div class="chat-bubble chat-bubble--right text-left">
                                        Hello dude!
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                <div class="">
                                    <template>
                                        <a-textarea placeholder="Your message here" :rows="4" />
                                    </template>
                                    <div class="row mt-3">
                                        <div class="col-6 kova-text text-left">
                                            <div class="row ml-3">
                                                <font-awesome-icon class="icon-1 pointer" icon="paperclip"></font-awesome-icon>
                                                <p class="font-weight-bolder ctrl-size-1 ml-2 pointer">Attach File</p>
                                            </div>
                                        </div>
                                        <div class="col-6 text-right">
                                            <button class="btn-kovatek py-2 px-3 px-md-4 px-lg-5 send">Send</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import Navbar from '@/components/Navbar.vue';
export default {
    name: 'chat',
    components: {
        Navbar
    },
    methods:{
        goBack(){
            this.$router.go(-1)
        }
    }
}
</script>

<style scoped>
.img-height{
    width: 50px;
    height: 50px
}
.dot{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: green;
}
.icon-1{
    font-size: 18px;
}
.ctrl-size{
    font-size: 18px;
}
.ctrl-size-1{
    font-size: 12px;
}
.ctrl-size-2{
    font-size: 9px;
}
.send{
    border-radius: 30px;
}
.ctrl-ellipsis{
    font-size: 20px;
}
.chat-bubble {
	padding: 10px 14px;
	background: #eee;
	margin: 10px 30px;
	border-radius: 9px;
	position: relative;
	animation: fadeIn 1s ease-in;
    
}
 .chat-bubble:after {
	content: '';
	position: absolute;
	top: 50%;
	width: 0;
	height: 0;
	border: 20px solid transparent;
	border-bottom: 0;
	margin-top: -10px;
    
}
.chat-bubble--right{
    background-color: rgb(31, 64, 152);
    color: #fff;
}
 .chat-bubble--left:after {
	left: 0;
	border-right-color: #eee;
	border-left: 0;
	margin-left: -10px;
}
 .chat-bubble--right:after {
	right: 0;
	border-left-color: rgb(31, 64, 152);
	border-right: 0;
	margin-right: -10px;
}

@media screen and (min-width: 992px) and (max-width: 1325px){
    
}

@media screen and (min-width: 992px) and (max-width: 1200px){
    .ctrl-size{
       font-size: 15px;
   }
}

@media screen and (min-width: 768px) and (max-width: 991px){
   .ctrl-size{
       font-size: 14px;
   }
}

@media screen and (max-width: 767px){
    
}

@media screen and (max-width: 550px){
}
</style>